module.exports = __webpack_public_path__ + "fonts/iconfont.6ec283c5.woff2";